import { Typography } from "@mui/material";
import { useLoaderData } from "react-router-dom";

import HNSColors from "../../../../../ui library/HNSColors";

export default function DetailSectionContent({ title, description }) {
  const { id } = useLoaderData();

  return (
    <div
      className="flex h-full w-full flex-col gap-3 overflow-y-auto rounded-[14px] bg-white p-6"
    >
      <Typography
        className="text-[20px] font-semibold"
        sx={{ color: HNSColors.neutrals[100] }}
      >
        {title}
      </Typography>
      <Typography className="text-[14px]" sx={{ color: HNSColors.neutrals[400] }}>
        {description}
      </Typography>
      <Typography className="text-[13px]" sx={{ color: HNSColors.neutrals[500] }}>
        Active record id: {id}
      </Typography>
    </div>
  );
}
